import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { Link, useMatch } from "react-router-dom";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/shared/components/primitives/sidebar";

export type TenkoNavSecondaryItem = {
  to: string;
  path?: string;
  label: string;
  icon?: ReactNode;
};

function TenkoNavSecondaryEntry({ item }: { item: TenkoNavSecondaryItem }) {
  const match = useMatch({ path: item.to, end: false });

  return (
    <SidebarMenuItem>
      <SidebarMenuButton isActive={!!match} render={<Link to={item.to} />}>
        {item.icon}
        <span>{item.label}</span>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}

export function TenkoNavSecondary({
  items,
  ...props
}: {
  items: TenkoNavSecondaryItem[];
} & ComponentPropsWithoutRef<typeof SidebarGroup>) {
  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => (
            <TenkoNavSecondaryEntry key={item.to} item={item} />
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
